import React from 'react'
import { useNavigate } from 'react-router-dom';
import ciLogo from '../../assets/niq.png';
import "./layout.css"

type Props = { isAdmin: boolean, email: string };

const Topbar: React.FC<Props> = ({ isAdmin = false, email }) => {
    const navigate = useNavigate();
    return (
        // <div className='flex justify-between items-center p-3 bg-primary text-black'>
        //     <i className='pi pi-home text-2xl'></i>
        //     {email && isAdmin && <span>{email}</span>}
        // </div>
        <>
            <div
                className="header-block fixed-top bg-white border-bottom w-100"
                style={{
                    height: 60,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0 32px', // add horizontal padding
                    zIndex: 1050 // ensure it stays on top
                }}
            >
                <img
                    className="navbar-brand"
                    src={ciLogo}
                    alt="logo"
                    style={{
                        cursor: 'pointer',
                        objectFit: 'contain',
                        height: 48,
                        width: '25%',
                        display: 'block'
                    }}
                    onClick={() => navigate('/AppCenter/home')}
                />
                {email && isAdmin && (
                    <span style={{ fontWeight: 500 }}>{email}</span>
                )}
            </div>
        </>
    )
}

export default Topbar